import { InicioTemplate } from "../../Templates/InicioTemplate";

export const Inicio = () => {
  return <InicioTemplate />;
};
